import { Chip, TextField } from '@material-ui/core'
import { FC, useCallback, useEffect, useState } from 'react'
import { useCurrentUser } from '../../commons/currentuser/CurrentUserHook';
import { userService } from '../../../_services/user.service';
import { Autocomplete } from '@material-ui/lab';
import { ListedUser } from '../../users/listedUser.model';

type Props = {
  value?: ListedUser[];
  excludeUserId?: string;
  onChange?: (users: ListedUser[]) => void;
}

const AttendeesSelect: FC<Props> = ({ value = [], excludeUserId, onChange }) => {

  const { user } = useCurrentUser();
  const [users, setUsers] = useState<ListedUser[]>()

  const fetch = useCallback(
    async () => {
      const allUsers = await userService.getUnListed('')
      // Exclude the booking owner from attendees list
      const filteredUsers = excludeUserId
        ? allUsers.filter(u => u.id !== excludeUserId)
        : allUsers;
      setUsers(filteredUsers)
    },
    [excludeUserId],
  )

  useEffect(() => {
    fetch()
  }, [user, fetch])

  const handleChange = (_event: object, newValue: (string | ListedUser)[]) => {
    const users = newValue.filter((item): item is ListedUser => typeof item !== 'string')
    onChange && onChange(users)
  }

  return (
    <>
      {!!users &&
        <Autocomplete
          multiple
          disableCloseOnSelect
          id="attendees-select"
          value={value}
          options={users}
          getOptionLabel={(option) => `${option.firstname} ${option.lastname}`}
          getOptionSelected={(option, value) => option.id === value.id}
          onChange={handleChange}
          fullWidth={true}
          renderTags={(tagValue, getTagProps) =>
            tagValue.map((option, index) => (
              <Chip
                label={`${option.firstname} ${option.lastname}`}
                size="small"
                {...getTagProps({ index })}
              />
            ))
          }
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder={value.length === 0 ? "Agregar invitados" : ""}
              size="small"
            />
          )}
        />
      }
    </>
  )
}

export default AttendeesSelect
